import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Header from "./header";
import MenuBar from "./navbar";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import swal from "sweetalert";
import {
  BASE_URL,
  PRODUCTS_LIST,
  HSN_LIST,
  PER_QTY_RATE_LIST,
  TAX_TYPE_LIST,
  TAX_STATE_LIST,
  PRODUCT_HSN_MAPPER,
  isTokenValid,
} from "./utility";
import { Navigate } from "react-router-dom";
import Select from "react-select";

const DeliveryChallan = (props) => {
  const productOptions = PRODUCTS_LIST.map((p) => ({
    value: p.value,
    label: p.text,
  }));

  const [state, setState] = useState({
    challanNo: "",
    challanDate: new Date(),
    placeOfSupply: "",
    deliveryFor: "",
    receivedBy: "",
    deliveredBy: "",
    taxState: "",
    taxType: "",

    productname1: "",
    hsn1: "",
    qty1: "",
    ratePerQty1: "",

    productname2: "",
    hsn2: "",
    qty2: "",
    ratePerQty2: "",

    productname3: "",
    hsn3: "",
    qty3: "",
    ratePerQty3: "",

    productname4: "",
    hsn4: "",
    qty4: "",
    ratePerQty4: "",

    productname5: "",
    hsn5: "",
    qty5: "",
    ratePerQty5: "",
  });

  const handleInput = (e) => {
    const { name, value } = e.target;

    if (name.includes("productname")) {
      const idx = name.match(/\d+/)[0];
      setState({
        ...state,
        [name]: value,
        ["hsn" + idx]: PRODUCT_HSN_MAPPER[value] || "",
      });
    } else {
      setState({ ...state, [name]: value });
    }
  };

  const buildItems = () => {
    const items = [];
    for (let i = 1; i <= 5; i++) {
      const name = state[`productname${i}`];
      const hsn = state[`hsn${i}`];
      const qty = state[`qty${i}`];
      const unit = state[`ratePerQty${i}`];

      if (name && hsn && qty && unit) {
        items.push({
          sno: items.length + 1,
          name,
          hsn,
          qty,
          unit,
        });
      }
    }
    return items;
  };

  const generateInvoice = (e) => {
    e.preventDefault();

    if (!state.productname1) {
      swal("Please add at least one product");
      return;
    }

    const payload = {
      challanNo: state.challanNo,
      date: state.challanDate,
      placeOfSupply: state.placeOfSupply,
      deliveryFor: state.deliveryFor,
      type: "challan",
      taxState: state.taxState,
      taxType: state.taxType,
      receivedBy: state.receivedBy,
      deliveredBy: state.deliveredBy,
      items: buildItems(),
    };

    fetch(BASE_URL + "generateInvoice", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
      body: JSON.stringify(payload),
    })
      .then((res) => res.blob())
      .then((blob) => {
        const file = window.URL.createObjectURL(blob);
        window.location.assign(file);
      });
  };

  if (!isTokenValid()) return <Navigate to="/auth" replace />;

  return (
    <div style={{ backgroundImage: `url(${BASE_URL}download/general/bg)` }}>
      <Header />
       <MenuBar />
      <center>
        <h2 style={{ color: "white" }}>{props.desc}</h2>
      </center>

      <div style={{ padding: "5%", color: "white" }}>
        <Form onSubmit={generateInvoice}>
          <Form.Group className="mb-3">
            <Form.Label>Challan No</Form.Label>
            <Form.Control name="challanNo" onChange={handleInput} />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Date</Form.Label>
            <DatePicker
              selected={state.challanDate}
              onChange={(d) => setState({ ...state, challanDate: d })}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Place Of Supply</Form.Label>
            <Form.Control
              name="placeOfSupply"
              onChange={handleInput}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Delivery For</Form.Label>
            <Form.Control
              name="deliveryFor"
              onChange={handleInput}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Received By</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              name="receivedBy"
              onChange={handleInput}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Delivered By</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              name="deliveredBy"
              onChange={handleInput}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Tax State</Form.Label>
            <select
              className="form-control"
              name="taxState"
              onChange={handleInput}
              required
            >
              {TAX_STATE_LIST.map((t) => (
                <option key={t.value} value={t.value}>
                  {t.text}
                </option>
              ))}
            </select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Tax Type</Form.Label>
            <select
              className="form-control"
              name="taxType"
              onChange={handleInput}
              required
            >
              {TAX_TYPE_LIST.map((t) => (
                <option key={t.value} value={t.value}>
                  {t.text}
                </option>
              ))}
            </select>
          </Form.Group>

          {/* Product Rows */}
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} style={{ marginBottom: "10px" }}>
              <Form inline>
                <Form.Group>
                  <Select
                    options={productOptions}
                    value={productOptions.find(
                      (option) =>
                        option.value === state[`productname${i}`]
                    )}
                    onChange={(o) =>
                      handleInput({
                        target: {
                          name: `productname${i}`,
                          value: o.value,
                        },
                      })
                    }
                    placeholder="Select product..."
                    isSearchable
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        width: 250,
                        color: "black",
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        color: "black",
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        color: "black",
                        backgroundColor: state.isFocused
                          ? "#f0f0f0"
                          : "white",
                      }),
                    }}
                  />

                  <select
                    style={{ width: "150px" }}
                    className="form-control"
                    name={`hsn${i}`}
                    value={state[`hsn${i}`]}
                    onChange={handleInput}
                  >
                    {HSN_LIST.map((h) => (
                      <option key={h.value} value={h.value}>
                        {h.text}
                      </option>
                    ))}
                  </select>

                  <Form.Control
                    style={{ width: "150px" }}
                    type="number"
                    name={`qty${i}`}
                    placeholder="Qty"
                    onChange={handleInput}
                  />

                  <select
                    style={{ width: "150px" }}
                    className="form-control"
                    name={`ratePerQty${i}`}
                    onChange={handleInput}
                  >
                    {PER_QTY_RATE_LIST.map((u) => (
                      <option key={u.value} value={u.value}>
                        {u.text}
                      </option>
                    ))}
                  </select>
                </Form.Group>
              </Form>
            </div>
          ))}

          <br />
          <Button type="submit">Generate Challan</Button>
        </Form>
      </div>
    </div>
  );
};

export default DeliveryChallan;
